<div class="flex h-screen w-full items-center justify-center bg-white dark:bg-vivid-royal-950">
  <div class="w-full max-w-md px-6 py-10">

    <!-- Logo -->
    <div class="mb-8 text-center">
      <img src="./assets/logos/energo_logo.svg" class="mx-auto w-40 dark:hidden" alt="Logo" />
      <img src="./assets/logos/energo_logo_dark.svg" class="mx-auto w-40 hidden dark:block" alt="Logo" />
    </div>

    <!-- Loading -->
    @if(enProceso) {
      <div class="text-center py-10">
        <i class="pi pi-spin pi-spinner text-2xl text-vivid-royal-400"></i>
        <p class="text-sm text-vivid-royal-400 mt-3">Procesando activación...</p>
      </div>
    }

    <!-- Success -->
    @if(showResponse && showSuccess && !enProceso) {
      <div class="text-center space-y-4">
        <div class="w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center mx-auto">
          <i class="pi pi-check text-3xl text-green-500"></i>
        </div>
        <h1 class="text-xl font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">Usuario activado</h1>
        <p class="text-sm text-vivid-royal-400">El usuario ya puede acceder al portal con sus credenciales.</p>
      </div>
    }

    <!-- Error -->
    @if(showResponse && !showSuccess && !enProceso) {
      <div class="text-center space-y-4">
        <div class="w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mx-auto">
          <i class="pi pi-times text-3xl text-red-500"></i>
        </div>
        <h1 class="text-xl font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">No pudimos activar el usuario</h1>
        <p class="text-sm text-vivid-royal-400">Intente de nuevo o contacte a su administrador.</p>
      </div>
    }

    <!-- Activate button -->
    @if(!showResponse && !enProceso && !showOtp) {
      <div class="text-center space-y-6">
        <div class="w-16 h-16 rounded-full bg-vivid-royal-100 dark:bg-vivid-royal-800 flex items-center justify-center mx-auto">
          <i class="pi pi-user-plus text-2xl text-vivid-royal-500 dark:text-vivid-royal-300"></i>
        </div>
        <h1 class="text-xl font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">Activar usuario</h1>

        <div class="bg-amber-50 dark:bg-amber-900/20 border border-amber-300 dark:border-amber-700 rounded-lg p-4 text-left">
          <div class="flex items-start gap-2">
            <i class="pi pi-exclamation-triangle text-amber-500 mt-0.5"></i>
            <p class="text-xs text-amber-700 dark:text-amber-300">
              Si es un usuario movimiento, podrá realizar cambios en tu cuenta tales como crear y asignar dispositivos, dar de alta conductores y asignarlos a dispositivos.
            </p>
          </div>
        </div>

        <button pButton label="Activar usuario" icon="pi pi-check" class="p-button-sm w-full" (click)="sendRequestActivate()"></button>
      </div>
    }
  </div>
</div>

@if(showOtp) {
  <app-auth-code-form-user [phoneNumber]="''" [email]="this.data" [clientNumber]="client" [dialcode]="'52'"
    (closeModal)="closeForm($event)" [IsPhone]="true" (validate)="closeForm($event)" [isRecovery]="false"
    [isBlock]="false" [info]="token" [isActivate]="true" [isDriver]="false">
  </app-auth-code-form-user>
}
